import { render } from "./AppTitleY.vue?vue&type=template&id=3f507376&scoped=true"
import script from "./AppTitleY.vue?vue&type=script&lang=js"
export * from "./AppTitleY.vue?vue&type=script&lang=js"

import "./AppTitleY.vue?vue&type=style&index=0&id=3f507376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f507376"]])

export default __exports__